// src/components/templates/MainLayout.js
import React from "react";
import TopAppBar from "../navigation/TopAppBar";
import BottomNav from "../navigation/BottomNav";
import { TOP_APP_BAR_HEIGHT } from "../../constants/constants";
import { BOTTOM_NAV_BAR_HEIGHT } from "../../constants/constants";
import { Box, Container } from "@mui/material";

const MainLayout = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" sx={{ backgroundColor: 'white', }}>
      <TopAppBar />
      {/* Spacer to offset the fixed TopAppBar */}
      <Box sx={{ height: `${TOP_APP_BAR_HEIGHT}px` }} />
      <Container
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 0, sm: 0 },
          py: { xs: 0, sm: 0 },
          mx: { xs: 0, sm: 0 },
          my: { xs: 0, sm: 0 },
          // mb: "130px",
          maxWidth: { xs: "100%", lg: "lg", xl: "xl" },
        }}
      >
        {children}
      </Container>
      {/* Spacer to offset the fixed BottomNav */}
      <Box sx={{ height: `${BOTTOM_NAV_BAR_HEIGHT}px` }} />
      <BottomNav />
    </Box>
  );
};

export default MainLayout;
